import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

import { Page } from '../../theme/components/Page'
import { PageSection } from '../../theme/components/PageSection'
import { useHoofdleidingValuelists } from '../../valuelists/hooks/useHoofdleidingValuelists'
import { useValuelists } from '../../valuelists/hooks/useValuelists'
import { GeblokkeerdeWekenFilters } from '../components/GeblokkeerdeWekenFilters'
import { PlanningByGebied } from '../components/PlanningByGebied'
import { useGeblokkeerdeWekenSearch } from '../hooks/useGeblokkeerdeWekenSearch'
import { useUpdateGeblokkeerdeWeek } from '../hooks/useUpdateGeblokkeerdeWeek'
import type { GeblokkeerdeWeek } from '../types/GeblokkeerdeWeek'

export { Planning }

const Planning = () => {
  const { data: valuelists } = useValuelists()
  const { data: hoofdleidingValuelists } = useHoofdleidingValuelists()
  const {
    isLoading,
    data: { items: planning },
    initialFilters,
    onChangeFilters,
    filters,
    onReset,
  } = useGeblokkeerdeWekenSearch()

  const { mutate: updateGeblokkeerdeWeek } = useUpdateGeblokkeerdeWeek()

  const handleRemove = (geblokkeerdeWeek: GeblokkeerdeWeek) => {
    updateGeblokkeerdeWeek({
      geblokkeerdeWeek: { ...geblokkeerdeWeek, status: 'inactief' },
    })
  }

  return (
    <Page
      title={['Geblokkeerde weken']}
      breadcrumbs={[
        { label: 'Home', href: '/home', tooltip: 'CAPO home' },
        { label: 'Geblokkeerde weken' },
      ]}
      gap={4}
    >
      <PageSection id="geblokkeerde-weken" heading="Geblokkeerde weken">
        <Alert
          severity="info"
          sx={{ maxWidth: { lg: '50%' }, marginBottom: 4 }}
        >
          <AlertTitle>Over geblokkeerde weken</AlertTitle>
          Onderstaande weken zijn voor de CAPO Hoofdleidingen projecten
          gemarkeerd als ‘geblokkeerd’. Bijvoorbeeld omdat er niet gewerkt wordt
          tijdens de bouwvak of het kerstreces. Bijlagen en activiteiten die
          automatisch gepland worden zullen niet in deze weken worden gepland.
          Projectverantwoordelijken (bijv. de combi) kunnen deze weken zelf
          blokkeren per gebied, uiteraard in overleg met alle stakeholders in
          dat gebied. Deze weken zijn niet van toepassing op CAPO Aansluiting
          projecten. Daar kunnen bepaalde weken worden geblokkeerd voor
          aanvragers. Dit kan ingesteld worden via de Servicedesk.
        </Alert>
      </PageSection>

      <GeblokkeerdeWekenFilters
        onChange={onChangeFilters}
        filters={filters}
        initialFilters={initialFilters}
        onReset={onReset}
        filterOptions={{
          ...valuelists,
          hoofdleiding: hoofdleidingValuelists,
        }}
      />

      {isLoading && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {!isLoading && planning.length > 0 && (
        <PlanningByGebied planning={planning} onRemove={handleRemove} />
      )}

      {!planning.length && !isLoading && (
        <Typography>
          Deze organisatie gebruikt geen geblokkeerde weken.
        </Typography>
      )}
    </Page>
  )
}
